
export const changeTheme = (lang) =>  document.documentElement.setAttribute('data-theme', lang === 'ua' ? 'yellow' : 'green')
